import React from 'react';
import { SortByOption } from '@sonar-software/sonar-ts-types';
import { UpdateQueryParams } from '@hooks';
import { SortByFilter, SortByFilterQueryParams } from '@periscopes/general/filters';

export interface SortedBySelectProps {
	defaultValue?: SortByOption;
	onChange: UpdateQueryParams<SortByFilterQueryParams>;
	queryParams: SortByFilterQueryParams;
	sortOptions: Array<SortByOption>;
}

export const SortedBySelect: React.FC<SortedBySelectProps> = ({ defaultValue, onChange, queryParams, sortOptions }) => {
	if (!sortOptions.length) {
		return null;
	}

	const defaultOption = defaultValue ?? sortOptions[ 0 ];

	return (
		<SortByFilter
			defaultSortOption={ defaultOption }
			onChange={ onChange }
			options={ sortOptions }
			queryParams={ queryParams }
			sortIcon />
	);
};
